if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(
          `#Recipient-fields-live-region-${this.dataset.sectionId}`
        );
        this.checkboxInput = this.querySelector(
          `#Recipient-checkbox-${this.dataset.sectionId}`
        );
        this.checkboxInput.disabled = false;
        this.hiddenControlField = null;
        this.emailInput = this.querySelector(
          `#Recipient-email-${this.dataset.sectionId}`
        );
        this.nameInput = this.querySelector(
          `#Recipient-name-${this.dataset.sectionId}`
        );
        this.messageInput = this.querySelector(
          `#Recipient-message-${this.dataset.sectionId}`
        );
        this.sendonInput = this.querySelector(
          `#Recipient-send-on-${this.dataset.sectionId}`
        );
        // Aggiungi i campi del mittente
        this.senderEmailInput = this.querySelector(
          `#Sender-email-${this.dataset.sectionId}`
        );
        this.senderNameInput = this.querySelector(
          `#Sender-name-${this.dataset.sectionId}`
        );
        // Rimuoviamo il timezone offset - non più necessario
        this.offsetProperty = null;

        this.errorMessageWrapper = this.querySelector(
          '.product-form__recipient-error-message-wrapper'
        );
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage =
          this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));

        // Inizializza limitazione quantità per Gift Card
        this.initializeQuantityLimitation();

        // Inizializza i campi come non required all'avvio
        this.setFieldsRequired(false);

        this.onChange();
      }

      connectedCallback() {
        // Intercetta il click sui bottoni di aggiunta al carrello
        this.setupFormValidation();
        // Assicura che i campi siano inclusi nel form
        this.ensureFieldsInForm();
        // Aggiungi validazione al form principale
        this.setupFormSubmitValidation();
      }

      ensureFieldsInForm() {
        // Trova il form del prodotto che contiene il bottone add to cart
        const productForm =
          this.closest('form') ||
          document.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('[data-product-form]');

        if (productForm && !productForm.contains(this)) {
          // Se il recipient-form non è dentro il form, spostiamo i suoi input nel form
          // Questo assicura che i dati vengano inviati con il submit
        }
      }

      setupFormValidation() {
        // Aspetta che il DOM sia completamente caricato
        setTimeout(() => {
          // Trova tutti i possibili bottoni di aggiunta al carrello
          const addToCartButtons = document.querySelectorAll(
            'cart-add, cart-btn, .btn-add-to-cart, button[name="add"], [data-add-to-cart]'
          );

          addToCartButtons.forEach((button) => {
            // Intercetta il click
            button.addEventListener(
              'click',
              (e) => {
                if (this.checkboxInput && this.checkboxInput.checked) {
                  if (!this.validateRecipientFields()) {
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                    this.showValidationErrors();
                    return false;
                  } else {
                    // I dati verranno inviati come properties dell'ordine
                  }
                }
              },
              true
            ); // Usa capture phase per intercettare prima di altri handler
          });

          // Intercetta anche eventi custom che potrebbero essere usati dal tema
          document.addEventListener(
            'cart:add',
            (e) => {
              if (this.checkboxInput && this.checkboxInput.checked) {
                if (!this.validateRecipientFields()) {
                  e.preventDefault();
                  e.stopPropagation();
                  this.showValidationErrors();
                  return false;
                }
              }
            },
            true
          );

          // Intercetta submit di form se presente
          const forms = document.querySelectorAll('form[action*="/cart/add"]');
          forms.forEach((form) => {
            form.addEventListener(
              'submit',
              (e) => {
                if (this.checkboxInput && this.checkboxInput.checked) {
                  if (!this.validateRecipientFields()) {
                    e.preventDefault();
                    e.stopPropagation();
                    this.showValidationErrors();
                    return false;
                  } else {
                    // I dati verranno inviati come properties dell'ordine
                  }
                }
              },
              true
            );
          });

          // Intercetta fetch per /cart/add per assicurarsi che i dati vengano passati
          const originalFetch = window.fetch;
          window.fetch = async (url, options) => {
            if (typeof url === 'string' && url.includes('/cart/add')) {
              // Se è una Gift Card, verifica la quantità
              if (this.isGiftCardProduct()) {
                // Forza la quantità a 1
                if (options && options.body) {
                  if (options.body instanceof FormData) {
                    options.body.set('quantity', '1');
                  } else if (typeof options.body === 'string') {
                    try {
                      const bodyData = JSON.parse(options.body);
                      bodyData.quantity = 1;
                      options.body = JSON.stringify(bodyData);
                    } catch (e) {
                      // Se è URLSearchParams
                      const params = new URLSearchParams(options.body);
                      params.set('quantity', '1');
                      options.body = params.toString();
                    }
                  }
                }

                // Verifica che non ci siano altre Gift Card nel carrello
                try {
                  const cartResponse = await fetch('/cart.js');
                  const cartData = await cartResponse.json();
                  const validation = this.validateGiftCardQuantity(cartData);
                  if (!validation.valid) {
                    this.showGiftCardError(
                      validation.errorType,
                      validation.message
                    );
                    return Promise.reject(new Error(validation.message));
                  }
                } catch (error) {
                  console.error('Errore nel verificare il carrello:', error);
                }
              }

              if (this.checkboxInput && this.checkboxInput.checked) {
                if (!this.validateRecipientFields()) {
                  this.showValidationErrors();
                  return Promise.reject(
                    new Error('Gift card recipient validation failed')
                  );
                }

                // Se la validazione passa, assicura che i dati del recipient siano inclusi
                if (options && options.body) {
                  // Aggiungi i dati del recipient come attributi dell'ordine (note)
                  const recipientData = this.getRecipientData();

                  // Se il body è FormData, aggiungi gli attributi
                  if (options.body instanceof FormData) {
                    this.addOrderAttributesToFormData(
                      options.body,
                      recipientData
                    );
                  }
                  // Se il body è una stringa JSON
                  else if (typeof options.body === 'string') {
                    try {
                      const bodyData = JSON.parse(options.body);
                      // Aggiungi gli attributi dell'ordine
                      bodyData.attributes = bodyData.attributes || {};
                      Object.assign(
                        bodyData.attributes,
                        recipientData.attributes
                      );
                      options.body = JSON.stringify(bodyData);
                    } catch (e) {
                      // Non-JSON body format, skip
                    }
                  }
                }
              }
            }
            return originalFetch(url, options);
          };
        }, 100); // Piccolo delay per assicurarsi che tutti i componenti siano caricati
      }

      setupFormSubmitValidation() {
        // Trova il form principale che contiene il recipient form
        const parentForm = this.closest('form');
        if (parentForm) {
          // Aggiungi listener per il submit del form
          parentForm.addEventListener(
            'submit',
            (e) => {
              if (this.checkboxInput && this.checkboxInput.checked) {
                // Verifica che i campi required siano compilati
                const requiredFields = [
                  this.senderEmailInput,
                  this.senderNameInput,
                  this.emailInput,
                  this.nameInput,
                ];

                for (const field of requiredFields) {
                  if (field && (!field.value || field.value.trim() === '')) {
                    e.preventDefault();
                    e.stopPropagation();

                    // Triggera la validazione HTML5
                    if (field.reportValidity) {
                      field.reportValidity();
                    } else {
                      // Fallback per browser che non supportano reportValidity
                      field.focus();
                      this.showValidationErrors();
                    }
                    return false;
                  }
                }

                // Valida anche il formato email
                const emailFields = [this.senderEmailInput, this.emailInput];
                for (const field of emailFields) {
                  if (
                    field &&
                    field.value &&
                    !this.validateEmail(field.value)
                  ) {
                    e.preventDefault();
                    e.stopPropagation();
                    if (field.reportValidity) {
                      field.reportValidity();
                    } else {
                      field.focus();
                      this.showValidationErrors();
                    }
                    return false;
                  }
                }
              }
            },
            true
          ); // Usa capture phase
        }
      }

      validateRecipientFields() {
        if (!this.checkboxInput || !this.checkboxInput.checked) {
          return true;
        }

        let isValid = true;
        const errors = {};
        let errorType = null;

        // Valida sender email (OBBLIGATORIA)
        if (
          !this.senderEmailInput ||
          !this.senderEmailInput.value ||
          !this.senderEmailInput.value.trim()
        ) {
          errors['sender-email'] = [
            "Campo obbligatorio: inserisci l'email del mittente",
          ];
          errorType = 'recipient_required';
          isValid = false;
        } else if (!this.validateEmail(this.senderEmailInput.value)) {
          errors['sender-email'] = ['Formato email non valido'];
          errorType = 'sender_email_invalid';
          isValid = false;
        }

        // Valida sender nome (OBBLIGATORIO)
        if (
          !this.senderNameInput ||
          !this.senderNameInput.value ||
          !this.senderNameInput.value.trim()
        ) {
          errors['sender-name'] = [
            'Campo obbligatorio: inserisci il nome del mittente',
          ];
          if (!errorType) errorType = 'recipient_required';
          isValid = false;
        }

        // Valida email destinatario (OBBLIGATORIA)
        if (
          !this.emailInput ||
          !this.emailInput.value ||
          !this.emailInput.value.trim()
        ) {
          errors.email = [
            "Campo obbligatorio: inserisci l'email del destinatario",
          ];
          if (!errorType) errorType = 'recipient_required';
          isValid = false;
        } else if (!this.validateEmail(this.emailInput.value)) {
          errors.email = ['Formato email non valido'];
          errorType = 'recipient_email_invalid';
          isValid = false;
        }

        // Valida nome destinatario (OBBLIGATORIO)
        if (
          !this.nameInput ||
          !this.nameInput.value ||
          !this.nameInput.value.trim()
        ) {
          errors.name = [
            'Campo obbligatorio: inserisci il nome del destinatario',
          ];
          if (!errorType) errorType = 'recipient_required';
          isValid = false;
        }

        // Messaggio e data sono OPZIONALI - non validare
        // Il messaggio può essere vuoto
        // La data può essere vuota (Shopify userà la data corrente)

        if (!isValid) {
          this.validationErrors = errors;
          this.validationErrorType = errorType;
        } else {
        }

        return isValid;
      }

      validateEmail(email) {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(email);
      }

      showValidationErrors() {
        if (this.validationErrors) {
          this.displayErrorMessage(this.validationErrors);
          // Scrolla fino al primo campo con errore
          const firstError = this.querySelector('.has-error');
          if (firstError) {
            const field = firstError.querySelector(
              'input:not([type="hidden"]):not([disabled]), select:not([disabled]), textarea:not([disabled])'
            );
            if (field) field.focus({ preventScroll: true });
            firstError.scrollIntoView({
              behavior: 'auto',
              block: 'center',
            });
          }
        }
      }

      onChange() {
        const recipientFields = this.querySelector('.recipient-fields');
        if (this.checkboxInput.checked) {
          if (recipientFields) recipientFields.style.display = 'block';
          this.enableInputFields();
          this.setFieldsRequired(true);
          if (
            this.recipientFieldsLiveRegion &&
            window.accessibilityStrings?.recipientFormExpanded
          ) {
            this.recipientFieldsLiveRegion.innerText =
              window.accessibilityStrings.recipientFormExpanded;
          }
          this.clearErrorMessage();
        } else {
          if (recipientFields) recipientFields.style.display = 'none';
          this.clearInputFields();
          this.disableInputFields();
          this.setFieldsRequired(false);
          this.clearErrorMessage();
          if (
            this.recipientFieldsLiveRegion &&
            window.accessibilityStrings?.recipientFormCollapsed
          ) {
            this.recipientFieldsLiveRegion.innerText =
              window.accessibilityStrings.recipientFormCollapsed;
          }
        }
      }

      inputFields() {
        return [
          this.senderEmailInput,
          this.senderNameInput,
          this.emailInput,
          this.nameInput,
          this.messageInput,
          this.sendonInput,
        ];
      }

      disableableFields() {
        return [...this.inputFields()];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => {
          if (field) field.value = '';
        });
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => {
          if (field) field.disabled = false;
        });
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => {
          if (field) field.disabled = true;
        });
      }

      setFieldsRequired(required) {
        // Imposta l'attributo required sui campi obbligatori
        const requiredFields = [
          this.senderEmailInput,
          this.senderNameInput,
          this.emailInput,
          this.nameInput,
        ];

        requiredFields.forEach((field) => {
          if (field) {
            if (required) {
              field.setAttribute('required', '');
              field.required = true;
            } else {
              field.removeAttribute('required');
              field.required = false;
            }
          }
        });

        // Messaggio e data sono sempre opzionali
        if (this.messageInput) {
          this.messageInput.removeAttribute('required');
          this.messageInput.required = false;
        }
        if (this.sendonInput) {
          this.sendonInput.removeAttribute('required');
          this.sendonInput.required = false;
        }
      }

      displayErrorMessage(body) {
        this.clearErrorMessage();
        if (typeof body !== 'object') return;

        // Map validation error keys to input IDs
        const keyToIdMap = {
          'sender-email': `Sender-email-${this.dataset.sectionId}`,
          'sender-name': `Sender-name-${this.dataset.sectionId}`,
          email: `Recipient-email-${this.dataset.sectionId}`,
          name: `Recipient-name-${this.dataset.sectionId}`,
          message: `Recipient-message-${this.dataset.sectionId}`,
          send_on: `Recipient-send-on-${this.dataset.sectionId}`,
        };

        // Inizializza storage per le label originali
        if (!this._originalLabels) this._originalLabels = {};

        Object.entries(body).forEach(([key, value]) => {
          const message = Array.isArray(value) ? value.join(', ') : value;
          const fieldId = keyToIdMap[key];

          if (fieldId) {
            const inputElement = this.querySelector(`#${fieldId}`);
            if (inputElement) {
              const wrapper = inputElement.closest(
                'mc-input-text, mc-input-area'
              );
              if (wrapper) {
                wrapper.classList.add('has-error');
                // Sostituisci il testo della label con il messaggio d'errore
                const label = wrapper.querySelector('.form-label');
                if (label) {
                  if (!this._originalLabels[fieldId]) {
                    this._originalLabels[fieldId] = label.textContent;
                  }
                  label.textContent = message;
                  label.classList.add('text-danger');
                }
              }
              inputElement.classList.add(
                'border-danger',
                'text-danger',
                'placeholder-danger'
              );
              inputElement.setAttribute('aria-invalid', true);
            }
          }
        });
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        // Ripristina le label originali
        if (this._originalLabels) {
          Object.entries(this._originalLabels).forEach(([fieldId, text]) => {
            const inputElement = this.querySelector(`#${fieldId}`);
            if (inputElement) {
              const wrapper = inputElement.closest(
                'mc-input-text, mc-input-area'
              );
              if (wrapper) {
                const label = wrapper.querySelector('.form-label');
                if (label) {
                  label.textContent = text;
                  label.classList.remove('text-danger');
                }
              }
            }
          });
          this._originalLabels = {};
        }

        // Clear design system input errors and has-error class
        this.querySelectorAll('.has-error').forEach((el) => {
          el.classList.remove('has-error');
        });

        this.querySelectorAll('.invalid-feedback[data-error]').forEach(
          (field) => {
            field.textContent = '';
            field.style.display = '';
          }
        );

        [
          this.senderEmailInput,
          this.senderNameInput,
          this.emailInput,
          this.messageInput,
          this.nameInput,
          this.sendonInput,
        ].forEach((inputElement) => {
          if (inputElement) {
            inputElement.classList.remove(
              'border-danger',
              'text-danger',
              'placeholder-danger'
            );
            inputElement.setAttribute('aria-invalid', false);
            inputElement.removeAttribute('aria-describedby');
          }
        });

        this.validationErrors = null;
      }

      getRecipientData() {
        // Ottieni i dati del recipient form
        const data = {
          properties: {
            'Is Gift?': 'yes',
            'Gift card sender email': this.senderEmailInput?.value || '',
            'Gift card sender name': this.senderNameInput?.value || '',
            'Gift card recipient email': this.emailInput?.value || '',
            'Gift card recipient name': this.nameInput?.value || '',
            'Gift card message': this.messageInput?.value || '',
            'Gift card send datetime': this.sendonInput?.value || '',
          },
          attributes: {
            is_gift: 'yes',
            gift_card_sender_email: this.senderEmailInput?.value || '',
            gift_card_sender_name: this.senderNameInput?.value || '',
            gift_card_recipient_email: this.emailInput?.value || '',
            gift_card_recipient_name: this.nameInput?.value || '',
            gift_card_message: this.messageInput?.value || '',
            gift_card_send_datetime: this.sendonInput?.value || '',
          },
        };

        return data;
      }

      addOrderAttributesToFormData(formData, recipientData) {
        // Aggiungi gli attributi dell'ordine al FormData
        // Gli attributi vanno aggiunti come attributes[key]
        Object.entries(recipientData.attributes).forEach(([key, value]) => {
          if (value) {
            formData.append(`attributes[${key}]`, value);
          }
        });

        // Assicurati che anche le properties siano presenti (se non lo sono già)
        Object.entries(recipientData.properties).forEach(([key, value]) => {
          if (value && !formData.has(`properties[${key}]`)) {
            formData.append(`properties[${key}]`, value);
          }
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput && this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }

      initializeQuantityLimitation() {
        // Forza la quantità a 1 per Gift Card
        const quantityInputs = document.querySelectorAll(
          'input[name="quantity"]'
        );
        quantityInputs.forEach((input) => {
          input.value = '1';
          input.max = '1';
          input.setAttribute('readonly', 'readonly');
          input.addEventListener('change', (e) => {
            if (this.isGiftCardProduct()) {
              e.target.value = '1';
            }
          });
        });

        // Disabilita selettori di quantità
        const quantitySelectors = document.querySelectorAll(
          '.quantity-selector, .qty-selector, input-quantity'
        );
        quantitySelectors.forEach((selector) => {
          if (this.isGiftCardProduct()) {
            selector.style.display = 'none';
          }
        });
      }

      isGiftCardProduct() {
        // Verifica se il prodotto è una Gift Card
        // Cerca indicatori nel DOM che suggeriscano che sia una Gift Card
        const productForm =
          document.querySelector('form[action*="/cart/add"]') ||
          document.querySelector('#product-form');
        if (!productForm) return false;

        // Cerca metadati del prodotto o altri indicatori
        const isGiftCard =
          // Controlla se il form contiene il recipient form
          !!this.checkboxInput ||
          // Controlla se c'è un attributo data che indica Gift Card
          productForm.dataset.productType === 'Gift Card' ||
          // Controlla se il titolo contiene "Gift Card"
          document
            .querySelector('.prod-title')
            ?.textContent?.includes('Gift Card') ||
          document.querySelector('h1')?.textContent?.includes('Gift Card') ||
          // Controlla se c'è il componente recipient-form nella pagina
          !!document.querySelector('recipient-form');

        return isGiftCard;
      }

      validateGiftCardQuantity(cartData) {
        // Verifica che non ci siano altre Gift Card nel carrello
        if (!cartData || !cartData.items) return { valid: true };

        const giftCardItems = cartData.items.filter(
          (item) =>
            item.product_type === 'Gift Card' ||
            item.properties?.['Gift card recipient'] === 'yes'
        );

        if (giftCardItems.length > 0) {
          return {
            valid: false,
            errorType: 'gift_card_limit',
            message:
              'Limite Gift Card: È possibile acquistare solo una Gift Card per ordine. Hai già una Gift Card nel carrello.',
          };
        }

        return { valid: true };
      }

      showGiftCardError(errorType, customMessage) {
        const errorMessages = {
          gift_card_limit: {
            title: 'Limite quantità Gift Card',
            message:
              'È possibile acquistare solo una Gift Card per ordine. Rimuovi le Gift Card esistenti dal carrello per procedere.',
            icon: '⚠️',
          },
          gift_card_quantity: {
            title: 'Quantità non valida',
            message:
              'Le Gift Card possono essere acquistate solo in quantità singola (1 per ordine).',
            icon: '❌',
          },
          recipient_required: {
            title: 'Dati destinatario mancanti',
            message:
              'Per favore compila tutti i campi obbligatori del destinatario della Gift Card.',
            icon: '📝',
          },
          recipient_email_invalid: {
            title: 'Email non valida',
            message:
              "L'indirizzo email del destinatario non è valido. Controlla e riprova.",
            icon: '📧',
          },
          generic_error: {
            title: 'Errore',
            message: customMessage || 'Si è verificato un errore. Riprova.',
            icon: '❗',
          },
        };

        const error = errorMessages[errorType] || errorMessages.generic_error;

        // Crea un messaggio di errore formattato
        const formattedMessage = `
          <div class="gift-card-error-container">
            <div class="error-icon">${error.icon}</div>
            <div class="error-content">
              <strong>${error.title}</strong>
              <p>${error.message}</p>
            </div>
          </div>
        `;

        this.displayErrorMessage(formattedMessage);

        // Log per debug
        console.error(`Gift Card Error [${errorType}]:`, error.message);
      }
    }
  );
}
